import { parseRouting, ReviewDocument } from '../review/result-model'
import { supplyRequest } from './api'
import { DeliveryAnalysis } from './model'

export type AnalysisState = {
  status: 'processing' | 'review' | 'checked' | 'upload' | 'failed' | 'unavailable'
  documentId?: string
  documentCount?: number
  checkedCount?: number
  processingStage?: string
}
export const analysisLabel = (state: AnalysisState) => {
  switch (state.status) {
    case 'review':
      return { text: state.documentCount && state.checkedCount === state.documentCount ? 'Накладные проверены' : 'Готово к проверке', color: 'gold' }
    case 'checked':
      return { text: 'Приёмка подтверждена', color: 'green' }
    case 'failed':
      return { text: 'Не удалось разобрать', color: 'red' }
    case 'upload':
      return { text: 'Документы не отправлены', color: 'default' }
    case 'unavailable':
      return { text: 'Статус временно недоступен', color: 'default' }
    default:
      return { text: state.processingStage === 'awaiting_result' ? 'Дольше обычного · ждём результат' : state.processingStage === 'queued' ? 'В очереди' : state.processingStage === 'repairing' ? 'Уточняем данные' : state.processingStage === 'matching' ? 'Разбор и сверка' : 'Идёт разбор', color: 'blue' }
  }
}
export const analysisPath = (reviewId: string, state?: AnalysisState) =>
  `/warehouse/reviews/${reviewId}${
    state?.documentId ? `?document=${encodeURIComponent(state.documentId)}` : ''
  }`
export const savedAnalysisState = (analysis: DeliveryAnalysis): AnalysisState => ({
  status: analysis.status,
  documentId: analysis.document_id,
  documentCount: analysis.document_count,
  checkedCount: analysis.checked_count,
  ...(analysis.processing_state ? { processingStage: analysis.processing_state } : {}),
})
export async function synchronizeAnalysis(analysis: DeliveryAnalysis): Promise<AnalysisState> {
  if (analysis.document_count) return savedAnalysisState(analysis)
  if (analysis.processing_job_id) return { ...savedAnalysisState(analysis), status: analysis.processing_state === 'failed' ? 'failed' : ['uploading','cancelled'].includes(analysis.processing_state || '') ? 'upload' : 'processing' }
  if (!analysis.chat_id) return { status: 'upload' }
  let data: any
  try {
    data = (
      await supplyRequest(`/api/mcp2/codex/agents/${analysis.chat_id}?message_limit=30`, {
        timeoutMs: 20000,
      })
    ).data
  } catch (cause: any) {
    if (cause.statusCode === 404) return { status: 'failed' }
    throw cause
  }
  if (typeof data?.isProcessing !== 'boolean' || !Array.isArray(data?.messages))
    throw new Error('Не удалось получить состояние разбора')
  if (data?.isProcessing === true) return { status: 'processing' }
  const messages: any[] = Array.isArray(data?.messages) ? data.messages : []
  if (!messages.some(message => message.role === 'user')) return { status: 'upload' }
  const assistant = [...messages]
    .reverse()
    .find(
      message => message.role === 'assistant' && message.metadata?.codex_response_pending !== true,
    )
  if (
    !assistant ||
    assistant.metadata?.retryable === true ||
    assistant.metadata?.runtime_interrupted === true
  )
    return { status: 'failed' }
  const routing = parseRouting(assistant.content)
  if (!routing?.documents.length || !assistant.id || !assistant.created_at)
    return { status: 'failed' }
  try {
    await supplyRequest(`/api/supply/reviews/${analysis.review_id}/result`, {
      method: 'POST',
      timeoutMs: 60000,
      body: JSON.stringify({
        message_id: assistant.id,
        created_at: assistant.created_at,
        documents: routing.documents,
      }),
    })
  } catch (cause: any) {
    if (cause.statusCode === 400) return { status: 'failed' }
    throw cause
  }
  const response = await supplyRequest(`/api/supply/reviews/${analysis.review_id}/documents`)
  const documents: ReviewDocument[] = response.data || []
  if (!documents.length) return { status: 'failed' }
  const checked = documents.filter(document => document.status === 'confirmed').length
  return {
    status: 'review',
    documentId: documents[0].id,
    documentCount: documents.length,
    checkedCount: checked,
  }
}
